import { FC } from 'react';
import classNames from 'classnames';
import CustomImage from '@/components/CustomImage/CustomImage';

interface IconListingProps {
    listingItems: {
        title: string;
        image?: string;
    }[];
}

const NumberListing: FC<IconListingProps> = ({ listingItems }) => {
    // tw-grid-cols-${listingItems.length} can't be used due to https://tailwindcss.com/docs/content-configuration#dynamic-class-names
    let gridColsLenght = '';
    switch (listingItems.length) {
        case 2:
            gridColsLenght = 'tw-grid-cols-2';
            break;
        case 3:
            gridColsLenght = 'tw-grid-cols-3';
            break;
        case 4:
            gridColsLenght = 'tw-grid-cols-4';
            break;
        default:
            gridColsLenght = 'tw-grid-cols-3';
    }

    return (
        <div className="w-full tw-bg-[#F2FaFF] md:tw-bg-white tw-my-[30px]">
            <div className="container">
                <div className={classNames('tw-w-full tw-grid', gridColsLenght)}>
                    {listingItems.map((item) => (
                        <div
                            key={item.title}
                            className="
                                tw-flex tw-flex-col
                                md:tw-flex-row
                                tw-items-center
                                tw-py-[15px]
                                md:tw-h-[34px]
                                tw-text-center
                                md:tw-text-left
                                tw-box-content
                                md:tw-ml-[20px]
                                lg:tw-ml-[50px]

                            "
                        >
                            {item.image && (
                                <CustomImage
                                    src={item.image}
                                    alt={item.title}
                                    width={40}
                                    height={40}
                                />
                            )}
                            <h3
                                className={classNames(
                                    'tw-text-[#4B4F54] tw-text-[12px] lg:tw-text-[16px] lg:tw-leading-[25px] tw-font-gotham-medium tw-font-light',
                                    'tw-px-[5px] tw-mt-[15px] md:tw-ml-[15px] md:tw-mr-[10px] md:tw-mt-0 lg:tw-ml-[28px] lg:tw-mr-[10px]',
                                    {
                                        'max-[365px]:tw-text-[10px]': listingItems.length > 3,
                                    },
                                )}
                            >
                                {item.title}
                            </h3>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NumberListing;
